import { faUser, faUserCheck, f } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextField, Typography } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { httpService, loggedInUser } from "../httpService";
import { LoadingButton } from "@mui/lab";
import { AlertContext } from "../contexts/AlertContext";
import Swal from "sweetalert2";

export default function AttendanceMonitor() {
  const [result, setResult] = useState({ total: "0", verified: "0" });
  const [code, setCode] = useState("");
  const { setAlertData } = useContext(AlertContext);
  const [participant, setParticipant] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [deletingAll, setDeletingAll] = useState(false);
  const [finding, setFinding] = useState(false);

  const getData = async () => {
    const { data } = await httpService("attendancemonitor");

    if (data) {
      setResult(data);
    }
  };

  useEffect(() => {
    getData();

    const interval = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const findParticipant = async (e) => {
    e.preventDefault();
    setFinding(true);
    const { data, error } = await httpService.post("findparticipant", { code });
    if (data) setParticipant(data);

    if (error) {
      setParticipant(null);
      setAlertData({ open: true, message: error, severity: "error" });
    }
    setFinding(false);
  };

  const deleteVerification = async () => {
    setDeleting(true);
    const { data, error } = await httpService.delete(
      `deleteverification/${participant._id}`
    );
    if (data) {
      setParticipant(null);
      setAlertData({ open: true, message: data, severity: "success" });
    }

    if (error) {
      setAlertData({ open: true, message: error, severity: "error" });
    }
    setDeleting(false);
  };

  const deleteAll = () => {
    Swal.fire({
      icon: "question",
      title: "Delete all verifications?",
      text: "Admin are you sure????",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setDeletingAll(true);
        const { data, error } = await httpService.delete(
          "deleteallverifications"
        );
        if (data) {
          setAlertData({ open: true, message: data, severity: "success" });
        }

        if (error) {
          setAlertData({ open: true, message: error, severity: "error" });
        }
        setDeletingAll(false);
      }
    });
  };
  return (
    <div className="mb-5 mt-5">
      <div className="container">
        <div className="d-none d-lg-block">
          <div className="row">
            <div className="col-lg-6 totalRegistered d-flex align-items-center justify-content-center text-white text-center">
              <div>
                <FontAwesomeIcon icon={faUser} color="white" fontSize={100} />
                <div className="mt-3">
                  <Typography variant="h4" fontWeight={300}>
                    Total Registered
                  </Typography>
                </div>
                <div className="mt-3">
                  <Typography variant="h1" fontWeight={100}>
                    {result.total}
                  </Typography>
                </div>
              </div>
            </div>
            <div className="col-lg-6 totalAccredited d-flex align-items-center justify-content-center text-center text-white">
              <div>
                <FontAwesomeIcon
                  icon={faUserCheck}
                  color="white"
                  fontSize={100}
                />
                <div className="mt-3">
                  <Typography variant="h4" fontWeight={300}>
                    Total Verified
                  </Typography>
                </div>
                <div className="mt-3">
                  <Typography variant="h1" fontWeight={100}>
                    {result.verified}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-sm-block d-lg-none text-white">
          <div
            className="p-3 mb-3 d-flex justify-content-between align-items-center"
            style={{ backgroundColor: "#d74f5d" }}
          >
            <div>
              <FontAwesomeIcon icon={faUser} color="white" fontSize={40} />

              <div className="mt-2">
                <Typography>Total Registered</Typography>
              </div>
            </div>
            <div>
              <Typography variant="h4" fontWeight={300}>
                {result.total}
              </Typography>
            </div>
          </div>
          <div
            className="p-3 mb-3 d-flex justify-content-between align-items-center"
            style={{ backgroundColor: "#43cea2" }}
          >
            <div>
              <FontAwesomeIcon icon={faUserCheck} color="white" fontSize={40} />

              <div className="mt-2">
                <Typography>Total Verified</Typography>
              </div>
            </div>
            <div>
              <Typography variant="h4" fontWeight={300}>
                {result.verified}
              </Typography>
            </div>
          </div>
        </div>
        {loggedInUser.role === "admin" && (
          <div className="row mt-3">
            <div className="col-lg-4 mb-3">
              <form onSubmit={findParticipant}>
                <div className="mb-2">
                  <TextField
                    fullWidth
                    label="Registration Code"
                    required
                    onChange={(e) => setCode(e.target.value)}
                  />
                </div>
                <LoadingButton loading={finding} type="submit">
                  Find and delete
                </LoadingButton>
              </form>
              <div className="mt-2">
                {participant && (
                  <div>
                    <div className="alert alert-danger">
                      <div className="mb-1">
                        <Typography gutterBottom variant="caption">
                          Name:
                        </Typography>
                        <Typography>
                          {participant.title} {participant.firstName}{" "}
                          {participant.lastName}
                        </Typography>
                      </div>
                      <div className="mb-1">
                        <Typography gutterBottom variant="caption">
                          Institution:
                        </Typography>
                        <Typography>{participant.institution}</Typography>
                      </div>
                      <div className="mb-2">
                        <Typography gutterBottom variant="caption">
                          role:
                        </Typography>
                        <Typography>{participant.role}</Typography>
                      </div>
                      <LoadingButton
                        onClick={deleteVerification}
                        loading={deleting}
                        color="error"
                      >
                        Delete Verification
                      </LoadingButton>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-4 mb-3">
              <LoadingButton
                color="error"
                variant="contained"
                onClick={deleteAll}
                loading={deletingAll}
              >
                Clear all verifications
              </LoadingButton>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
